const { strings } = window.theme

class TagalysLibrary {
  static typeSuggestionsRender (html, args) {
    const props = args.props
    const helpers = props.helpers
    const textSuggestions = helpers.getTextSuggestions()

    const classes = ['sec-Section_TagalysSlides', 'tag-TypeSuggestions']
    if (helpers.hasTextSearchSuggestions() > 0) {
      classes.push('tag-TypeSuggestions-producttext')
    } else {
      classes.push('tag-TypeSuggestions-product')
    }
    const className = classes.join(' ')

    if (helpers.hasTextSearchSuggestions()) {
      const searchQueries = []
      const query = helpers.getEnteredSearchQuery()
      textSuggestions[0].items.forEach(item => {
        searchQueries.push(`
            <li class="fz-15_28">
              <a class="tag-SearchSuggestions_Suggestion" href="${
                item.link
              }">${item.displayString
          .replace(new RegExp(query, 'ig'), `<b>${query}</b>`)
          .replace(/^./, item.displayString.charAt(0).toUpperCase())}</a>
            </li>
          `)
      })

      const targetNode = document.querySelector(
        '[data-tagalys-search-el="suggestions"]',
      )
      targetNode.replaceChildren()
      targetNode.insertAdjacentHTML(
        'beforeend',
        `
          ${searchQueries.join(' ')}
        `,
      )
    }

    const resultCount = helpers.getProducts().length

    return html`
      <div class="tag-Title_Header">
        ${resultCount > 0
          ? html`
              <span
                class="tag-SearchSuggestions_Heading fz-15_19 tag-ResultTotal"
              ></span>
              <div class="klevuProductsViewAll ku-Title_ViewAll">
                <a
                  href="/pages/search-results?q=${helpers.getEnteredSearchQuery()}"
                  target="_parent"
                  class="ku-Title_Button ku-Button fz-15_19"
                >
                  Show all
                </a>
              </div>
            `
          : html`
              <p class="fz-15_28">
                We're sorry, no results found for
                "${helpers.getEnteredSearchQuery()}"
              </p>
            `}
      </div>
      <ul class=${className}>
        <${args.templates.products}
          className="tag-SearchSuggestions_Products"
        />
      </ul>
      <div class="tag-Title_Header">
        ${resultCount > 0
          ? html`
              <span
                class="tag-SearchSuggestions_Heading fz-15_19 tag-ResultTotal"
              ></span>
              <div class="klevuProductsViewAll ku-Title_ViewAll">
                <a
                  href="/pages/search-results?q=${helpers.getEnteredSearchQuery()}"
                  target="_parent"
                  class="ku-Title_Button ku-Button fz-15_19"
                >
                  Show all
                </a>
              </div>
            `
          : ''}
      </div>
    `
  }

  static rangeSliderFilterItem (html, args) {
    const props = args.props
    const helpers = props.helpers
    const labels = args.labels

    return html`
      <div class="range-slider filter-item">
        <div ref=${props.sliderRef} />
        <div class="input-group">
          <div class="input-container input-container-min">
            <input
              type="number"
              value=${props.sliderInputValues[0]}
              onblur=${props.onInputBlur}
              onchange=${props.onMinChange}
            />
            <label>
              ${helpers.labelFormatter(
                props.filter.display_format,
                props.filter.min,
                props.filter.currency,
              )}
            </label>
          </div>
          <span class="to">${labels.filters.rangeFilterValueSeparator}</span>
          <div class="input-container input-container-max">
            <input
              type="number"
              value=${props.sliderInputValues[1]}
              onblur=${props.onInputBlur}
              onchange=${props.onMaxChange}
            />
            <label>
              ${helpers.labelFormatter(
                props.filter.display_format,
                props.filter.max,
                props.filter.currency,
              )}
            </label>
          </div>
        </div>
      </div>
    `
  }

  static textSuggestionsSectionRender (html, args) {
    const props = args.props
    const textSuggestionSection = props.textSuggestionSection

    return html`
      <li
        class="text-suggestion-section"
        data-section-id=${textSuggestionSection.section_id}
      >
        <span class="section-title">
          ${textSuggestionSection.section_title}
        </span>
        <ul>
          ${textSuggestionSection.items.map(textSuggestionSectionItem => {
            return html`
              <${args.templates.textSuggestionSectionItem}
                textSuggestionSectionId=${textSuggestionSection.section_id}
                textSuggestionSectionItem=${textSuggestionSectionItem}
              />
            `
          })}
        </ul>
      </li>
    `
  }

  static quickLinkRender (html, args) {
    return html`
      <section class="tag-SearchSuggestions_QuickLinks">
        <header class="ku-Klevu_Header fz-15_28">
          ${window.TagalysTranslations?.how_can_we_help}
        </header>

        <div class="ku-Klevu_Body">
          <div class="ku-Klevu_Items">
            <div class="ku-Klevu_Item fz-15_28">
              <a href="/pages/shipping" class="tag-SearchSuggestions_QuickLink">
                ${window.BAO.Utils.parseHtmlEntities(
                  window.TagalysTranslations?.shipping,
                )}
              </a>
            </div>

            <div class="ku-Klevu_Item fz-15_28">
              <a href="/pages/returns" class="tag-SearchSuggestions_QuickLink"
                >${window.BAO.Utils.parseHtmlEntities(
                  window.TagalysTranslations?.returns,
                )}</a
              >
            </div>

            <div class="ku-Klevu_Item fz-15_28">
              <a
                href="/pages/store-listing"
                class="tag-SearchSuggestions_QuickLink"
                >${window.BAO.Utils.parseHtmlEntities(
                  window.TagalysTranslations?.stores,
                )}</a
              >
            </div>

            <div class="ku-Klevu_Item fz-15_28">
              <a href="/pages/faqs" class="tag-SearchSuggestions_QuickLink"
                >${window.BAO.Utils.parseHtmlEntities(
                  window.TagalysTranslations?.faqs,
                )}</a
              >
            </div>

            <div class="ku-Klevu_Item fz-15_28">
              <a href="/pages/contact" class="tag-SearchSuggestions_QuickLink"
                >${window.BAO.Utils.parseHtmlEntities(
                  window.TagalysTranslations?.contact_us,
                )}</a
              >
            </div>
          </div>
        </div>
      </section>
    `
  }

  static plainProductRender (product) {
    const onSale =
      product.compare_at_price_min !== product.price &&
      product.compare_at_price_min !== null &&
      product.compare_at_price_min !== 0
    const saleSticker = onSale
      ? `<p class="prd-Card_Sticker prd-Card_Sticker-sale fz-13_17">${window.theme.strings.stickerSale}</p>`
      : ''

    const badges = []
    product.tags.forEach(tag => {
      if (tag.includes('plp-badge')) {
        const badgeParts = tag.split(':')
        badges.push(badgeParts[1])
      }
    })

    const moreColours =
      product.title !== product.metafields?.details?.clean_title?.value

    const productTitle =
      product.metafields?.details?.clean_title?.value || product.title

    let productPrice = BAO.Utils.formatMoney(
      product.price * 100,
      theme.moneyFormat,
    )

    if (product.price === 0) {
      productPrice = ''
    }

    return `
      <li class="tag-SearchSuggestions_Product">
        <product-card-gallery>
          <article class="prd-Card util-FauxLink" data-product-card-gallery-el="card">
            <div class="prd-Card_ImageContainer keen-slider" data-product-card-gallery-el="slides">
              <div class="prd-Card_Image prd-Card_Image-active keen-slider__slide util_FauxLink" data-product-card-gallery-el="slide">
                <div class="rsp-Image">
                  <img
                    class="rsp-Image_Image"
                    src=${product.images[0].src}
                    alt=${product.title}
                  />
                </div>
                <a class="util-FauxLink_Link" href="${
                  product.__tagalys_fields.link
                }">
                  <span class="util-ScreenReaderOnly">
                    ${product.metafields.details.clean_title || product.title}
                  </span>
                </a> 
              </div>

              ${product.images
                ?.slice(1, 4)
                .map(
                  image => /* html */ `
                    <div class="prd-Card_Image keen-slider__slide util_FauxLink" data-product-card-gallery-el="slide">
                      <div class="rsp-Image">
                        <img
                          class="rsp-Image_Image"
                          src="${image.src}"
                          alt="${image.alt?.length ? image.alt : product.title}"
                        />
                      </div>
                      <a class="util-FauxLink_Link" href="${
                        product.__tagalys_fields.link
                      }">
                        <span class="util-ScreenReaderOnly">
                          ${product.metafields.details.clean_title ||
                            product.title}
                        </span>
                      </a> 
                    </div>
                  `,
                )
                .join('')}

              <button type="button" data-product-card-gallery-el="previous" class="prd-Card_NavButton prd-Card_NavButton-prev" aria-label="${
                strings.previousSlide
              }">
                <svg viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4.32.499 1.316 3.502 4.32 6.506"
                    stroke="currentColor"
                    stroke-linecap="round"
                  />
                </svg>
                <label class="util-ScreenReaderOnly">
                  ${strings.previousSlide}
                </label>
              </button>
          
              <button type="button" data-product-card-gallery-el="next" class="prd-Card_NavButton prd-Card_NavButton-next" aria-label="${
                strings.nextSlide
              }">
                <svg viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="m.68 6.506 3.005-3.004L.68.5" stroke="currentColor" stroke-linecap="round" />
                </svg>
                <label class="util-ScreenReaderOnly">
                  ${strings.nextSlide}
                </label>
              </button>
            </div>

             ${saleSticker}

           <div class="prd-Card_DotContainer">
              <div class="prd-Card_Dots">
                ${product.images
                  ?.slice(1, 4)
                  .map(
                    (_, i) => /* html */ `
                 <button
                    class="prd-Card_Dot"
                    type="button"
                    aria-current="${i === 0}"
                    data-index="${i + 1}"
                    data-product-card-gallery-el="dot"
                  >
                    <span class="util-ScreenReaderOnly">
                      Dot
                    </span>
                  </button>
                `,
                  )
                  .join('')}
              </div>
            </div>

            <div class="prd-Card_Body util-FauxLink fz-15_21">
              <div class="prd-Card_Details">
                <h3 class="prd-Card_Title">
                  ${productTitle}
                </h3>

                <p class="prd-Card_Price ${
                  onSale ? 'prd-Card_Price-onsale' : ''
                }">
                    <span class="prd-Card_Price">${productPrice}</span>

                  <s class="prd-Card_RegularPrice">
                    <span class="util-ScreenReaderOnly">Regular price</span>
                    ${BAO.Utils.formatMoney(
                      product.compare_at_price * 100,
                      theme.moneyFormat,
                    )}
                  </s>

                  <span class="prd-Card_SalePrice">
                    ${productPrice}
                  </span>
                </p>
              </div>

            <div class="prd-Card_Colours">
              <p class="prd-Card_Colour prd-Card_Colour-current fz-15_21">
                ${product.metafields.colours.title.value[0]}
              </p>
              ${
                moreColours
                  ? `
                  <p class="prd-Card_Colour prd-Card_Colour-more fz-15_21">
                    + More colours
                  </p>
                `
                  : ''
              }
            </div>

            <ul class="prd-Card_BadgeList" ${badges.length ? '' : 'hidden'}>
              ${badges.map(badge => {
                return `
                  <li class="prd-Card_Badge fz-11_13">${badge}</li>
                `
              })}
            </ul>

            <a class="util-FauxLink_Link" href="${
              product.__tagalys_fields.link
            }">
              <span class="util-ScreenReaderOnly">
                ${product.title}
              </span>
            </a>
          </div>

          </article>
        </product-card-gallery>
      </li>
    `
  }

  static recentSearchItemRender (html, args) {
    const props = args.props
    const helpers = props.helpers
    const enteredSearchQuery = helpers.getEnteredSearchQuery()
    return html`
      <li class="fz-15_28">
        <a
          class="tag-SearchSuggestions_PopularResult tag-SearchSuggestions_RecentResult"
          href=${helpers.getLink(props.recentSearch.queryString)}
        >
          <${args.templates.highlighter}
            label=${props.recentSearch.displayString}
            highlight=${enteredSearchQuery}
          />
        </a>
      </li>
    `
  }

  static productRender (html, args) {
    const props = args.props
    const product = props.product

    const onSale =
      product.compare_at_price !== product.price &&
      product.compare_at_price !== null &&
      product.compare_at_price !== 0

    const saleSticker = onSale
      ? `<p class="prd-Card_Sticker prd-Card_Sticker-sale fz-13_17">${window.theme.strings.stickerSale}</p>`
      : ''

    const badges = []
    product.tags.forEach(tag => {
      if (tag.includes('plp-badge')) {
        const badgeParts = tag.split(':')
        badges.push(badgeParts[1])
      }
    })

    const productTitle =
      product.metafields?.details?.clean_title?.value || product.title

    let productPrice = BAO.Utils.formatMoney(
      product.price * 100,
      theme.moneyFormat,
    )

    if (product.price === 0) {
      productPrice = ''
    }

    return html`
      <li class="tag-SearchSuggestions_Product">
        <tagalys-product-card-gallery>
          <article
            class="prd-Card util-FauxLink"
            data-tagalys-product-card-gallery-el="card"
          >
            <div
              class="prd-Card_ImageContainer keen-slider"
              data-tagalys-product-card-gallery-el="slides"
            >
              <div
                class="prd-Card_Image prd-Card_Image-active keen-slider__slide util_FauxLink"
                data-tagalys-product-card-gallery-el="slide"
              >
                <div class="rsp-Image">
                  <img
                    class="rsp-Image_Image"
                    src=${product.images[0].src}
                    alt=${product.title}
                  />
                </div>
                <a
                  class="util-FauxLink_Link"
                  href="${product.__tagalys_fields.link}"
                >
                  <span class="util-ScreenReaderOnly">
                    ${product.title}
                  </span>
                </a>
              </div>

              ${product.images?.slice(1, 4).map(
                image => html`
                  <div
                    class="prd-Card_Image keen-slider__slide util_FauxLink"
                    data-tagalys-product-card-gallery-el="slide"
                  >
                    <div class="rsp-Image">
                      <img
                        class="rsp-Image_Image product-image"
                        src="${image.src}"
                        alt="${productTitle}"
                      />
                    </div>
                    <a
                      class="util-FauxLink_Link"
                      href="${product.__tagalys_fields.link}"
                    >
                      <span class="util-ScreenReaderOnly">
                        ${product.title}
                      </span>
                    </a>
                  </div>
                `,
              )}

              <button
                type="button"
                data-tagalys-product-card-gallery-el="previous"
                class="prd-Card_NavButton prd-Card_NavButton-prev"
                aria-label="${strings.previousSlide}"
              >
                <svg
                  viewBox="0 0 5 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.32.499 1.316 3.502 4.32 6.506"
                    stroke="currentColor"
                    stroke-linecap="round"
                  />
                </svg>

                <label class="util-ScreenReaderOnly">
                  ${strings.previousSlide}
                </label>
              </button>

              <button
                type="button"
                data-tagalys-product-card-gallery-el="next"
                class="prd-Card_NavButton prd-Card_NavButton-next"
                aria-label="${strings.nextSlide}"
              >
                <svg
                  viewBox="0 0 5 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m.68 6.506 3.005-3.004L.68.5"
                    stroke="currentColor"
                    stroke-linecap="round"
                  />
                </svg>

                <label class="util-ScreenReaderOnly">
                  ${strings.nextSlide}
                </label>
              </button>
            </div>

            ${saleSticker}

            <div class="prd-Card_DotContainer">
              <div class="prd-Card_Dots">
                ${product.images?.slice(1, 4).map((_, i) => {
                  return html`
                    <button
                      class="prd-Card_Dot"
                      type="button"
                      aria-current="${i === 0}"
                      data-index="${i + 1}"
                      data-tagalys-product-card-gallery-el="dot"
                    >
                      <span class="util-ScreenReaderOnly">
                        Dot
                      </span>
                    </button>
                  `
                })}
              </div>
            </div>

            <div class="prd-Card_Body fz-15_21 util-FauxLink">
              <div class="prd-Card_Details">
                <h3 class="prd-Card_Title">
                  ${productTitle}
                </h3>
                <p
                  class="prd-Card_Price ${onSale
                    ? 'prd-Card_Price-onsale'
                    : ''}"
                >
                  <span class="prd-Card_Price">
                    ${productPrice}
                  </span>

                  <s class="prd-Card_RegularPrice">
                    <span class="util-ScreenReaderOnly">Regular price</span>
                    ${BAO.Utils.formatMoney(
                      product.compare_at_price * 100,
                      theme.moneyFormat,
                    )}
                  </s>

                  <span class="prd-Card_SalePrice">
                    ${productPrice}
                  </span>
                </p>
              </div>

              <div class="prd-Card_Colours">
                <p class="prd-Card_Colour prd-Card_Colour-current fz-15_21">
                  ${product.metafields.colours.title.value[0]}
                </p>
                ${[''].map(blank => {
                  return product.title !==
                    product.metafields?.details?.clean_title?.value
                    ? html`
                        <p
                          class="prd-Card_Colour prd-Card_Colour-more fz-15_21"
                        >
                          + More colours
                        </p>
                      `
                    : html``
                })}
              </div>

              <ul class="prd-Card_BadgeList" ${badges.length ? '' : 'hidden'}>
                ${badges.map(badge => {
                  return html`
                    <li class="prd-Card_Badge fz-11_13">${badge}</li>
                  `
                })}
              </ul>

              <a
                class="util-FauxLink_Link"
                href="${product.__tagalys_fields.link}"
              >
                <span class="util-ScreenReaderOnly">
                  ${product.title}
                </span>
              </a>
            </div>
          </article>
        </tagalys-product-card-gallery>
      </li>
    `
  }

  static popularSearchItemRender (html, args) {
    const props = args.props
    const helpers = props.helpers
    const enteredSearchQuery = helpers.getEnteredSearchQuery()

    return html`
      <li class="fz-15_28">
        <a
          class="tag-SearchSuggestions_PopularResult"
          href=${helpers.getLink(props.popularSearch.queryString)}
        >
          <${args.templates.highlighter}
            label=${props.popularSearch.displayString}
            highlight=${enteredSearchQuery}
          />
        </a>
      </li>
    `
  }
}

window.BAO.TagalysLibrary = TagalysLibrary
